import HeroSection from "../../components/ui/HeroSection"
import MasajeCaroussel from "../../components/ui/MasajeCaroussel"
import Beneficios from "../../components/ui/Beneficios"
import Mapa from "../../components/ui/Mapa"
import { Container } from "react-bootstrap"

const HomeScreen = () => {
  return (
    <>
      <HeroSection />
      <Container fluid="xxxl" className="d-flex flex-column align-items-center">
        <MasajeCaroussel />
        <Beneficios />
        {/* <Iconos /> */}
        <Mapa />
      </Container>
    </>
  )
}

export default HomeScreen
